/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectValidationParam
 */
export interface ProjectValidationParam {
    /**
     * the purchase order number
     * @type {string}
     * @memberof ProjectValidationParam
     */
    purchaseOrderNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectValidationParam
     */
    projectStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectValidationParam
     */
    projectEndDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectValidationParam
     */
    periodStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectValidationParam
     */
    periodEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationParam
     */
    extraDocumentName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationParam
     */
    extraDocumentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationParam
     */
    comment?: string;
    /**
     * ID of the billing profile selected for invoicing
     * @type {string}
     * @memberof ProjectValidationParam
     */
    selectedBillingProfileId?: string;
}

/**
 * Check if a given object implements the ProjectValidationParam interface.
 */
export function instanceOfProjectValidationParam(value: object): value is ProjectValidationParam {
    return true;
}

export function ProjectValidationParamFromJSON(json: any): ProjectValidationParam {
    return ProjectValidationParamFromJSONTyped(json, false);
}

export function ProjectValidationParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectValidationParam {
    if (json == null) {
        return json;
    }
    return {
        
        'purchaseOrderNumber': json['purchaseOrderNumber'] == null ? undefined : json['purchaseOrderNumber'],
        'projectStartDate': json['projectStartDate'] == null ? undefined : (new Date(json['projectStartDate'])),
        'projectEndDate': json['projectEndDate'] == null ? undefined : (new Date(json['projectEndDate'])),
        'periodStartDate': json['periodStartDate'] == null ? undefined : (new Date(json['periodStartDate'])),
        'periodEndDate': json['periodEndDate'] == null ? undefined : (new Date(json['periodEndDate'])),
        'extraDocumentName': json['extraDocumentName'] == null ? undefined : json['extraDocumentName'],
        'extraDocumentId': json['extraDocumentId'] == null ? undefined : json['extraDocumentId'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'selectedBillingProfileId': json['selectedBillingProfileId'] == null ? undefined : json['selectedBillingProfileId'],
    };
}

export function ProjectValidationParamToJSON(value?: ProjectValidationParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'purchaseOrderNumber': value['purchaseOrderNumber'],
        'projectStartDate': value['projectStartDate'] == null ? undefined : ((value['projectStartDate']).toISOString().substring(0,10)),
        'projectEndDate': value['projectEndDate'] == null ? undefined : ((value['projectEndDate']).toISOString().substring(0,10)),
        'periodStartDate': value['periodStartDate'] == null ? undefined : ((value['periodStartDate']).toISOString().substring(0,10)),
        'periodEndDate': value['periodEndDate'] == null ? undefined : ((value['periodEndDate']).toISOString().substring(0,10)),
        'extraDocumentName': value['extraDocumentName'],
        'extraDocumentId': value['extraDocumentId'],
        'comment': value['comment'],
        'selectedBillingProfileId': value['selectedBillingProfileId'],
    };
}

